import React, { useContext, useState, useEffect, useRef } from 'react';
import { Table, Input, Button, Popconfirm, Form, InputNumber } from 'antd';
import { EditOutlined } from "@ant-design/icons";
const EditableContext = React.createContext(null);

const EditableRow = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

const EditableCell = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef(null);
  const form = useContext(EditableContext);
  useEffect(() => {
    if (editing) {
      inputRef.current.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({
      [dataIndex]: record[dataIndex],
    });
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <span style={{display: 'flex', alignItems: 'center'}}>
        <Form.Item
          style={{
            margin: 0,
            width: 50
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title}不能为空`,
            },
          ]}
        >
          <InputNumber ref={inputRef} min={0} max={99999} formatter={val=>val} parser={val=>(val - 0).toFixed(2)} onPressEnter={save} onBlur={save} />
        </Form.Item>
        <EditOutlined />
      </span>
    ) : (
      <div
        className="editable-cell-value-wrap"
        style={{
          textAlign: 'center'
        }}
        onClick={toggleEdit}
      >
        {children}<EditOutlined />
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
export default props => {
  const { tableData, pagination, onChange, tableColumns, rowSelection, loading, updatePrice=()=>{} } = props;
  const [dataSource, setDataSource] = useState(tableData)
  useEffect(()=>{
    setDataSource(tableData)
  },[tableData])
  const handleSave = (row) => {
    updatePrice(row)
    const newData = [...dataSource];
    const index = newData.findIndex((item) => row.skuForStoreId === item.skuForStoreId);
    const item = newData[index];
    newData.splice(index, 1, { ...item, ...row });
    setDataSource(newData);
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const columns = tableColumns.map((col) => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: handleSave,
      }),
    };
  });
  return (
    <Table
      rowKey={record=>record.skuForStoreId}
      components={components}
      rowSelection={rowSelection}
      rowClassName='editable-row'
      dataSource={dataSource}
      pagination = {pagination}
      loading={loading}
      columns={columns}
      onChange={onChange}
    />
  )
}
